import axios from "axios";

export default {
  namespaced: true,
  state: {
    tours: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    toursMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_TOURS(state, payload) {
      state.tours = payload;
      state.isReceiving = false;
    },
    RECEIVING_TOURS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TOUR(state, payload) {
      console.log("RECEIVED TOUR", payload);
      state = Object.assign(state, {
        tours: [...state.tours, payload],
        isReceiving: false,
      })
    },
    RECEIVING_TOUR(state) {
      state.isReceiving = true;
    },
    UPDATED_TOUR(state, payload) {
      console.log(state.tours);
      console.log(payload);
      let index = state.tours.findIndex(tour => tour._id === payload._id);
      state = Object.assign(state, {
        tours: state.tours.map((tour, i) => {
          if (i === index) {
            return Object.assign({}, tour, payload);
          }
          return tour;
        }),
        isUpdating: false,
        toursMessage: 'Tours has been updating!',
      })
    },
    UPDATING_TOUR(state) {
      state.isUpdating = true;
    },
    DELETED_TOUR(state, payload) {
      let indexToDelete = state.tours.findIndex(tour => tour._id === payload._id);
      console.log(indexToDelete);
      let tours = [...state.tours];
      tours.splice(indexToDelete, 1);
      state = Object.assign(state, {
        tours: [...tours],
        isDeleting: false,
        idToDelete: null,
        toursMessage: 'Tour has been Deleted!',
      });
    },
    DELETING_TOUR(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    getToursRequest({dispatch}) {
      dispatch("receivingTours");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/tours';
      console.log(url)
      let header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "get",url: url,headers: header})
      .then(res => {
        dispatch("receiveTours", res.data);
      })
    },
    insertTourRequest({dispatch}, payload) {
      dispatch("receivingTours");
      var token = localStorage.getItem('token');    
      let url = 'https://api.accountxc.com:3100/insert/tour';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "post", url: url, headers: headers, data: data})
      .then(function (res) {
        dispatch("receiveTour", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async insertTourWithImageRequest({dispatch}, payload) {
      dispatch("receivingTours");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/tour/withimage';
      console.log(url)
      let data = new FormData();
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      data.append('image', payload.tourimage, payload.imagename); 
      delete payload['tourimage'];
      for (let x in payload) data.append(x, payload[x]);
      
      return axios({method: "post", url: url, headers: headers , data: data})
      .then(response =>{
        dispatch("receiveTour", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.reponse.data.error;
      });	
    },
    async insertTourDetailRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/tourdetail/' + payload.tourid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertTourVariationRequest({dispatch}, payload) {
      console.log(payload)
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/tourvariation/' + payload.tourid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertTourPriceRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/tourprice/' + payload.tourid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertTourSeasonRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/tourseason/' + payload.tourid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertTourAddonRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/touraddon/' + payload.tourid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertTourPlanRequest({dispatch}, payload) {
      console.log(payload)
      let url;
      let data;
      try{
        dispatch("doNothing");
        if(payload.planimage!=null){
          url = 'https://api.accountxc.com:3100/insert/tourplan/withimage/' + payload.tourid;
          data = new FormData();
          data.append('file', payload.planimage, payload.imagename); 
          delete payload['planimage'];
          for (let x in payload) {
            data.append(x, payload[x]);
          }
        }
        else{
          data = payload;
          url = 'https://api.accountxc.com:3100/insert/tourplan/' + payload.tourid;
        }
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "POST", url: url, headers: headers, data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateTourDetailRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/tourdetail/' + payload.tourdetailid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateTourVariationRequest({dispatch}, payload) {
      console.log(payload)
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/tourvariation/' + payload.variationid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateTourSeasonRequest({dispatch}, payload) {
      console.log(payload)
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/tourseason/' + payload.seasonid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateTourPlanRequest({dispatch}, payload) {
      let url;
      let data;
      try{
        dispatch("doNothing");
        if(payload.planimage!=null){
          url = 'https://api.accountxc.com:3100/update/tourplan/withimage/' + payload.tourplanid;
          data = new FormData();
          data.append('file', payload.planimage, payload.imagename); 
          delete payload['planimage'];
          for (let x in payload) {
            data.append(x, payload[x]);
          }
        }
        else{
          data = payload;
          url = 'https://api.accountxc.com:3100/update/tourplan/' + payload.tourplanid;
        }
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "PUT", url: url, headers: headers, data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteTourVariationRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/tourvariation/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteTourPriceRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/tourprice/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteTourDetailRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/tourdetail/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteTourPlanRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/tourplan/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteTourSeasonRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/tourseason/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteTourAddonRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/touraddon/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateTourRequest({dispatch}, payload) {
      dispatch("updatingTour");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/tour/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "PUT", url: url, headers: header, data: payload})
      .then(function (response) {
        dispatch("updateTour", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateTourOptionsRequest({dispatch}, payload) {
      dispatch("updatingTour");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/tour/options/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "PUT", url: url, headers: header, data: payload})
      .then(function (response) {
        dispatch("updateTour", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateTourImageRequest({dispatch}, payload) {
      dispatch("updatingTour");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];

      let url = 'https://api.accountxc.com:3100/update/tour/image/' + id;
      let data = new FormData();
      data.append('file', payload.imagefile, payload.imagename); 
      delete payload['tourimage'];
      for (let x in payload) data.append(x, payload[x]);
      let header = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      return axios({method: "PUT", url: url, headers: header,data: data})
      .then(function (response) {
        dispatch("updateTour", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async updateTourPriceRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/tourprice/' + payload.priceid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    deleteTourRequest({dispatch}, payload) {
      dispatch("deletingTour", payload);
      console.log(payload);
      axios.get('https://api.accountxc.com:3100/delete/tour/' + payload._id).then(() => {
        dispatch("deleteTour", {_id: payload._id});
      })
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveTours({commit}, payload) {
      commit("RECEIVED_TOURS", payload)
    },
    receivingTours({commit}) {
      commit("RECEIVING_TOURS")
    },
    receiveTour({commit}, payload) {
      commit("RECEIVED_TOUR", payload)
    },
    receivingTour({commit}) {
      commit("RECEIVING_TOUR")
    },
    updateTour({commit}, payload) {
      commit("UPDATED_TOUR", payload)
    },
    updatingTour({commit}) {
      commit("UPDATING_TOUR")
    },
    deleteTour({commit}, payload) {
      commit("DELETED_TOUR", payload)
    },
    deletingTour({commit}, payload) {
      commit("DELETING_TOUR", payload)
    }
  },
};
